import handler from '../handler/handler'
import loginMessages from '../handler/messages/login-messages'
import updateMessages from '../handler/messages/update-messages'
import deleteMessages from '../handler/messages/delete-messages'

const loginHandler = handler(loginMessages.login)
const logoutHandler = handler(loginMessages.logout)
const updateHandler = handler(updateMessages)
const deleteHandler = handler(deleteMessages)

const tokenName = 'winepointUserToken'

export default {
  state: {
    userInfo: {
      name: '',
    },
  },
  getters: {
    user: state => state.userInfo,

    getToken: () => {
      const token = document.cookie.match(`(^|;) ?${tokenName}=([^;]*)(;|$)`)
      return token ? token[2] : null
    },
  },
  mutations: {
    initUser: (state, userInfo) => {
      state.userInfo = userInfo
    },

    clearUser: (state) => {
      state.userInfo = {
        name: '',
      }
    },

    setTokenInCookie: (state, { token, time }) => {
      const date = new Date()
      date.setTime(date.getTime() + (time * 1000 * 60 * 60))
      document.cookie = `${tokenName}=${token};expires=${date.toUTCString()};path=/`
    },

    deleteTokenInCookie: (state, name) => {
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:01 GMT;`
    },
  },
  actions: {
    login: async ({ commit }, user) => {
      const result = await loginHandler.post({ commit }, '/api/users/login', user)

      if (result.response) {
        commit('setTokenInCookie', { token: result.response.token, time: 24 })
        commit('initUser', result.response.user)
        commit('setFoldState', false)
      }

      return result
    },

    logout: async ({ commit, getters }) => {
      const result = await logoutHandler.authPost({ commit, getters }, '/api/users/logout')

      commit('deleteTokenInCookie', tokenName)
      commit('clearUser')
      commit('setFoldState', true)
      return result
    },

    updateUserProfile: async ({ commit, getters }, { id, name, phone, email }) => {
      const user = {
        name,
        phone,
        email,
      }

      const result = await updateHandler.authPut({ commit, getters }, `/api/users/${id}/profile`, user)
      return result
    },

    changePassword: async ({ commit, getters }, { id, password, confirmPassword }) => {
      const user = {
        password,
        confirmPassword,
      }

      const result = await updateHandler.authPut({ commit, getters }, `/api/users/${id}/change_password`, user)

      return result
    },

    modifyUser: async ({ commit, getters }, { id, isStore, isFc, isMaster, isStaff, isManager, isDeleted }) => {
      const user = {
        id,
        isStore,
        isFc,
        isMaster,
        isStaff,
        isManager,
        isDeleted,
      }

      const result = await updateHandler.authPut({ commit, getters }, `/api/users/${user.id}`, user)
      return result
    },

    modifyWpUser: async ({ commit, getters }, { id, email, phone, password }) => {
      const user = {
        id,
        email,
        phone,
        password,
      }

      await updateHandler.authPut({ commit, getters }, `/api/wp-users/modify/${user.id}`, user)
    },

    deleteUser: async ({ commit, getters }, { id }) => {
      const result = await deleteHandler.authDelete({ commit, getters }, `/api/users/${id}`)

      return result
    },

    deleteWpUser: async ({ commit, getters }, { id }) => {
      const result = await deleteHandler.authDelete({ commit, getters }, `/api/wp-users/${id}`)

      return result
    },

    confirmRequestSignupUser: async ({ commit, getters }, { id }) => {
      const result = await updateHandler.authPost({ commit, getters }, `/api/signup/${id}/confirm`)
      return result
    },
  },
}



// WEBPACK FOOTER //
// ./src/vuex/modules/user.js